import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Button, Menu, MenuItem } from "@mui/material";
import MyTemplateForm from "./MyTemplateForm";
import { setCurrentEmms } from "../../redux/slices/currentEmmsSlice";
import { setEmmsHeaders } from "../../redux/slices/emmsAuthSlice";
import Templates from "./Templates";
import Login from "../Login";
import TitleWithDropdown from "../TitleWithDropdown";
import image from "../../logos/templates.png";
import "../../components/CommonDashboard.css";
import { setTemplate } from "../../redux/slices/templateSlice";

function TemplatesDashboard({ selected }) {
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const headers = useSelector((state) => state.header);
  const [login, setLogin] = useState(false);

  const [responseData, setResponseData] = useState(null);
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);
  const [isFormVisible, setIsFormVisible] = useState(false); 
  const [selectedChoice, setSelectedChoice] = useState(false); 
  const [anchorEl, setAnchorEl] = useState(null); 

  const fetchData = (value) => {
    setIsLoading(true);
    let selectedEmms = emms?.emms?.find((element) => element.id === value);

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "template",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setResponseData(response.data);
          dispatch(setTemplate(response.data));
          setErrors(false);
        })
        .catch(() => {
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchData(selectedOption);
  }, [selectedOption]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChoiceSelect = () => {
    setSelectedChoice(true); 
    setAnchorEl(null); 
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  return login == null ? (
    <Login />
  ) : (
    <div className="mainContainer emms-main-container">
      <header style={{ marginLeft: "10%" }}>
        <figure>
          <img className="img content-ai-header-image" src={image} alt="Logo" />
        </figure>
      </header>
      <div className="title-container">
        <div className="title">
          <TitleWithDropdown
            title="EMMS Service"
            options={options}
            selectedOption={selectedOption}
            onOptionChange={(event) => setSelectedOption(event.target.value)}
          />
        </div>
        <div>
          <MyTemplateForm selectedOption={selectedOption} />
        </div>
      </div>

      <div  className="emms-main-container-left-align" style={{ marginLeft: "10%" }}>
        <Templates selectedOption={selectedOption} errors={errors} isLoading={isLoading} />
      </div>
    </div>
  );
}

export default TemplatesDashboard;
